'use client';

import { useEffect } from 'react';
import type { Country } from '@/helpers/conf';
import { ANJOUAN_COUNTRIES } from '@/modules/policies/constants';
import { useGetCommonStore } from '@/store';

declare global {
  interface Window {
    dlag_7bec17af_0e81_480d_a720_3a26d57b495c?: {
      init: () => void;
    };
  }
}

export const FooterTobiqueSeal = () => {
  const useCommonStore = useGetCommonStore();
  const countryCode = useCommonStore.use.countryCode();

  // Check if the current country requires Tobique licensing (NOT in Anjouan countries)
  const isTobiqueCountry = !ANJOUAN_COUNTRIES.includes(countryCode as Country);

  useEffect(() => {
    // Initialize the Tobique seal after component mounts
    if (
      isTobiqueCountry &&
      typeof window !== 'undefined' &&
      window.dlag_7bec17af_0e81_480d_a720_3a26d57b495c
    ) {
      window.dlag_7bec17af_0e81_480d_a720_3a26d57b495c.init();
    }
  }, [isTobiqueCountry]);

  // Only render for Tobique countries
  if (!isTobiqueCountry) {
    return null;
  }

  return (
    <div
      data-dlag-image-size="128"
      data-dlag-image-type="basic-light-small"
      data-dlag-seal-id="7bec17af-0e81-480d-a720-3a26d57b495c"
      id="dlag-7bec17af-0e81-480d-a720-3a26d57b495c"
    />
  );
};
